import React from "react";
import { Container, Navbar, NavDropdown } from "react-bootstrap";
import { BoxArrowRight } from "react-bootstrap-icons";
import { useAuthenticatedUser } from "../contexts/UserContext";
import { Button } from "./Button";

export const Navigation = () => {
  const { user, signOut } = useAuthenticatedUser();

  return (
    <Navbar className="mb-3">
      <Container>
        <Navbar.Brand href="#home">Student-overview-thesis.xlsx</Navbar.Brand>
        <NavDropdown title={user?.email} id="navUserDropdown" align="end">
          <NavDropdown.Item as={Button} icon={BoxArrowRight} onClick={signOut}>Sign out</NavDropdown.Item>
        </NavDropdown>
      </Container>
    </Navbar>
  );
}
